/**
 * Catalog MV2 QueryClient singleton.
 */
import { makeMv2QueryClient } from "@/features/_mv2/makeQueryClient";
import { setupMv2CachePersist } from "@/features/_mv2/mv2CachePersist";
import {
  CATALOG_PRODUCTS_QUERY_KEY,
  fetchCatalogProductsFromApi,
} from "./catalogQueryApi";

export const catalogQueryClient = makeMv2QueryClient();
setupMv2CachePersist(catalogQueryClient, "catalog");

export function prefetchCatalog() {
  return catalogQueryClient.prefetchQuery({
    queryKey: [CATALOG_PRODUCTS_QUERY_KEY],
    queryFn: ({ signal }) => fetchCatalogProductsFromApi(signal),
  });
}
